import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Text, Title, Wrapper} from './UnderMaintenance.style';

const UnderMaintenance = () => {
    return (
      <Wrapper>
        <Title><FormattedMessage id="underMaintenance.title" /></Title>
        <Text><FormattedMessage id="underMaintenance.text" /></Text>
      </Wrapper>
    );
};

export default UnderMaintenance;



// WEBPACK FOOTER //
// ./containers/UnderMaintenance/UnderMaintenance.js